export default theme => ({

  flex: {
    flex: 1
  }

});





// WEBPACK FOOTER //
// ./src/styles/components/TopBar.js